import React, { Component } from 'react'
import localStorage from 'localStorage'
import { getAuth, signInWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth";

import CustomSnackbar from 'components/Snackbar';

import { Get } from 'utils/axios'

const HOC = ( WrappedComponent ) => {

  class WithHOC extends Component {

    state={
      showSnackbar:false,
      snackbarMessage: '',
      snackbarType: '',
      onCloseSnackbar: () => {},

      loading: false,
      loadingCount: 0,
      showForgetPassword: false,
      loginCredential: {
        email: '',
        password: '',
      },
      rememberMe: false,
      recoverEmail: '',
      savedAccounts: [],
      showSavedAccounts: false
    }

    componentDidMount() {
      // Load all saved accounts
      const savedAccountsStr = localStorage.getItem('savedLoginAccounts')
      if (savedAccountsStr) {
        try {
          const savedAccounts = JSON.parse(savedAccountsStr)
          this.setState({ savedAccounts })
        } catch (e) {
          console.error('Error loading saved accounts:', e)
        }
      }
    }

    selectSavedAccount = (account) => {
      this.setState({
        loginCredential: {
          email: account.email,
          password: account.password
        },
        rememberMe: true,
        showSavedAccounts: false
      })
    }

    removeSavedAccount = (emailToRemove) => {
      const { savedAccounts } = this.state
      const updatedAccounts = savedAccounts.filter(acc => acc.email !== emailToRemove)
      localStorage.setItem('savedLoginAccounts', JSON.stringify(updatedAccounts))
      this.setState({ savedAccounts: updatedAccounts })
    }

    load = param => {
      this.setState((prevState) => {
        const newCount = param ? prevState.loadingCount + 1 : prevState.loadingCount - 1
        return {
          loading: newCount > 0,
          loadingCount: newCount
        }
      })
    }
    requestError = error => this.setState({
      showSnackbar: true,
      snackbarType: 'error',
      onCloseSnackbar: () => this.setState({ showSnackbar: false }),
      snackbarMessage: error
    })
    requestSuccess = ( success, callback ) => this.setState({
      showSnackbar: true,
      snackbarType: 'success',
      onCloseSnackbar: () => {
        this.setState({ showSnackbar: false })
        callback && callback()
      },
      snackbarMessage: success
    })
    onChangeLoginHOC = ( val, context ) => this.setState({ [ context ]: val })

    userLogin = () => {
      this.load( true )
      const auth = getAuth();
      let temp = this.state.loginCredential
      
      // Save account to multi-account list if remember me is checked
      if (this.state.rememberMe) {
        const savedAccountsStr = localStorage.getItem('savedLoginAccounts')
        let savedAccounts = []
        
        if (savedAccountsStr) {
          try {
            savedAccounts = JSON.parse(savedAccountsStr)
          } catch (e) {
            savedAccounts = []
          }
        }
        
        // Check if account already exists
        const existingIndex = savedAccounts.findIndex(acc => acc.email === temp.email)
        
        if (existingIndex >= 0) {
          // Update existing account password
          savedAccounts[existingIndex] = temp
        } else {
          // Add new account
          savedAccounts.push(temp)
        }
        
        localStorage.setItem('savedLoginAccounts', JSON.stringify(savedAccounts))
        this.setState({ savedAccounts })
      }
      
      signInWithEmailAndPassword( auth, temp.email, temp.password)
        .then((userCredential) => {
          this.getUser( userCredential.user.uid )
        })
        .catch((error) => {
          this.requestError( error.message )
          this.load( false )
        });
    }

    recoverPassword = () => {
      this.load( true )
      const auth = getAuth();
      sendPasswordResetEmail( auth, this.state.recoverEmail ).then(() => {
        this.load( false )
        window.alert( 'Please check your email to recover your password.' )
        this.setState({ showForgetPassword: false })
      }).catch( error  => {
        this.load( false )
        this.requestError( error.message )
      })
    }

    getUser = ( uid ) => Get(
      `/getUser?uid=${ uid }`,
      this.getUserSuccess,
      this.getUserError,
      this.load
    )
    getUserSuccess = payload => {
      localStorage.setItem( 'userLogin', JSON.stringify( payload.data ) )
      this.requestSuccess( 'Login Success.' )
      // Force reload to trigger navigation in useEffect
      setTimeout(() => {
        window.location.reload()
      }, 500)
    }
    getUserError = error => this.requestError( error.message )
    
    render = () => {
      return (
        <>
          <WrappedComponent
            { ... this.props }
            { ... this.state }
            onLoginLoad={ this.state.loading }
            rememberMe={ this.state.rememberMe }
            savedAccounts={ this.state.savedAccounts }
            showSavedAccounts={ this.state.showSavedAccounts }

            onChangeLoginHOC={ this.onChangeLoginHOC }
            recoverPassword={ this.recoverPassword }
            userLogin={ this.userLogin }
            selectSavedAccount={ this.selectSavedAccount }
            removeSavedAccount={ this.removeSavedAccount }
          />
          <CustomSnackbar
            open={ this.state.showSnackbar }
            message={ this.state.snackbarMessage }
            onClick={ this.state.onCloseSnackbar }
            type={ this.state.snackbarType }
            />
        </>
      )
    }
  }

  return WithHOC
}

export default HOC